import * as React from 'react';
import { HocOptions } from '@common/generic-hoc.types';
import { StylesProps } from '@theme/jss-types';
import { RouteChildrenProps } from 'react-router';
import { dropoffStyles } from '@dropoff/dropoff.styles';
import GenericHoc from '@common/generic-hoc';
import CustomTabs from '@components/common/Tabs';
import TabularDropoff from '@tabularDropoff/tabularDropoff';
import {
  Form,
  Input,
  Button,
  message,
  Row,
  Col,
  Modal,
  Table,
  Tooltip,
  Tag,
  Card,
  Divider,
  Typography,
  Select,
  List,
  Alert,
} from 'antd';
import {
  dropoff_invalid,
  dropoff_success,
} from '@assets/index';
import {
  verifyDropoff,
  resendSMS,
  weightMismatchPaymentLink,
  getWeightMismatchSubmit,
  weightMismatchValues,
  editShipmentDetails,
  getCommodityData,
  getPriceAndTat,
  getPriceAndTatInternational,
}
  from '@network/dropoff.api';
import {
  DropOffPayload,
} from '@dropoff/dropoff.types';
import
{
  weightMismatchColumns,
  collectionCompleteDiableText,
} from '@tabularDropoff/masterData';
import moment from 'moment';
import lodash from 'lodash';
import FormItem from 'antd/es/form/FormItem';
import {
  CloseOutlined,
  ReloadOutlined,
  InfoCircleOutlined,
  EditOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  DownOutlined,
} from '@ant-design/icons';
import PackageOption from './package-option/package';
import PaymentModal from './payment-link';

interface DropoffProps
  extends StylesProps<ReturnType<typeof dropoffStyles>>, RouteChildrenProps {
}
const { useState } = React;
const { Title } = Typography;

const DropoffPage = (props : DropoffProps) => {
  const {
    classes,
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [collectionLoading, setCollectionLoading] = useState<boolean>(false);
  const [showValidDropoff, setShowValidDropoff] = useState<boolean>(false);
  const [showInvalidDropoff, setShowInvalidDropoff] = useState<boolean>(false);
  const [showDropoffDetails, setShowDropoffDetails] = useState<boolean>(false);
  const [ShowDifferntialCost, setShowDifferntialCost] = useState<boolean>(false);
  const [modalLoading, setModalLoading] = useState<boolean>(false);
  const [dropOffFormData, setDropOffFormData] = useState<Record<string, string| null>>({
    referenceNumber: null,
    validationCode: null,
  });
  const [dropOffDetailsData, setDropOffDetailsData] = useState<any>({});
  const [dropOffMessage, setDropOffMessage] = useState<string>('');
  const [form] = Form.useForm();
  const [ShowPaymentStatus, SetShowPaymentStatus] = useState<string>('none');
  const [amountPending, setPaymentAmountPending] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isPackageModalOpen, setIsPackageModalOpen] = useState<boolean>(false);
  const [verifiedConsignmentDetail, setVerifiedConsignmentDetails] = useState<any>(null);
  const [lastDropOffCode, setLastDropOffCode] = useState<any>(null);
  const [isCollectCashModalOpen, setCollectCashModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [editingWightmmismatch, seteditingWeightmismatch] = useState<any>([]);
  const [dataSource, setDataSource] = useState<any>([]);
  const [consignmentEmail, setConsignmentEmail] = useState<string>('');
  const [paymentLinkButtonText, setPaymentLinkButtonText] = useState<string>('Send Payment Link');
  const [communicationModalTitle, setcommunicationModalTitle] = useState<string>('WEIGHT MISMATCH');
  const [isCashToOnlineDropoff, setIsCashToOnlineDropoff] = useState<boolean>(false);
  const [isDropoffPaymentLinkSent, setIsDropoffPaymentLinkSent] = useState<boolean>(false);
  const [consignmentPaymentStatus, setConsignmentPaymentStatus] = useState<string>('none');
  const [visibleSubmitButton, setVisibleSubmitButton] = useState<boolean>(false);
  const [isWeightMismatchDisabled, setIsWeightMismatchDisabled] = useState<boolean>(false);
  const [differentialCost, setDifferentialCost] = useState<any>(0);
  const [isPaymentAwaited, setisPaymentAwaited] = useState<boolean>(false);
  const [visiblePaymentStatus, setVisiblePaymentStatus] = useState<boolean>(true);
  const [isCommunicationModal, setIsCommunicationModal] = useState<boolean>(false);
  const [consignmentphone, setconsignmentphone] = useState<string>('');
  const [isValidPhone, setValidPhone] = useState<boolean>(true);
  const [isValidEmail, setValidEmail] = useState<boolean>(true);
  const [isInternationalConsignment, setIsInternational] = useState<boolean>(true);
  const [refNum, setRefNum] = useState<string>('');
  const [packagingAmount, setPackagingAmount] = useState<number>(0);
  const [tariffCharges, setTariffCharges] = useState<number>(0);
  const [isFullPageModalOpen, setIsFullPageModalOpen] = useState(false);
  const [isEditDetailsModalOpen, setIsEditDetailsModalOpen] = useState<boolean>(false);
  const [contentTypes, setContentTypes] = React.useState<{ value: string; label: string }[]>([]);
  const [serviceTypes, setServiceTypes] = useState<Array<{
    serviceType: string;
    price: number;
    hash: string;
  }>>([]);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState<boolean>(false);
  const [editDetailsAmount, setEditDetailsAmount] = useState<number>(0);
  const [locationChangeAmount, setLocationChangeAmount] = useState<number>(0);
  const [locationPaymentQueuedAfterEdit,
    setLocationPaymentQueuedAfterEdit] = useState<boolean>(false);
  const [shouldRecalcAfterLocationPayment,
    setShouldRecalcAfterLocationPayment] = useState<boolean>(false);
  const [amountToShow, setAmountToShow] = useState<number>(0);
  const [editDetailsFormData, setEditDetailsFormData] = useState({
    contentType: '',
    serviceType: '',
    destinationName: '',
    destinationAddressLine1: '',
    destinationAddressLine2: '',
    destinationPincode: '',
  });
  const [destinationDetailsData, setDestinationDetailsData] = useState<any>({
    Name: '',
    Phone: '',
    Email: '',
    City: '',
    Pincode: '',
    State: '',
    Country: '',
    AddressLine1: '',
    AddressLine2: '',
    previousName: '',
    previousPincode: '',
    previousAddressLine1: '',
    previousAddressLine2: '',
  });
  const [originDetailsData, setOriginDetailsData] = useState<any>({
    Name: '',
    Phone: '',
    Email: '',
    City: '',
    Pincode: '',
    State: '',
    Country: '',
    AddressLine1: '',
    AddressLine2: '',
  });
  const [paymentMode, setPaymentMode] = useState<string>('');
  const [referenceNum, setReferenceNum] = useState<string>('');
  const [isAlertModalOpen, setIsAlertModalOpen] = useState<boolean>(false);
  const [isLocationChange, setIsLocationChange] = useState<boolean>(false);
  const [shipmentChangeStatus, setShipmentChangeStatus] = useState<string>('none');
  const [locationChangeStatus, setLocationChangeStatus] = useState<string>('none');
  const [shipmentDetails, setShipmentDetails] = useState<any>({
    bookingDate: '',
    serviceType: '',
    previousServiceType: '',
    previousCommodity: '',
    riskSurcharge: '',
    loadType: '',
    content: '',
    shipAssure: '',
    originalWeight: '',
    originalLength: '',
    originalWidth: '',
    originalHeight: '',
    originalVolume: '',
    weightMismatchWeight: '',
    weightMismatchLength: '',
    weightMismatchWidth: '',
    weightMismatchHeight: '',
    weightMismatchVolume: '',
    declaredValue: '',
  });
  const [isServiceTypeValid, setIsServiceTypeValid] = useState<boolean>(true);

  const currentPackagingPaymentStatus = verifiedConsignmentDetail?.packingDetails?.paymentStatus;


  const renderConsignmentNumber = () => {
    return (
      <Form.Item
        name="referencenumber"
        className={classes.formLabel}
        label="Enter AWB / Reference No."
        colon={false}
        rules={[{
          required: true,
          message: 'AWB / Reference No. number is required',
        }]}
      >
        <Input
          className={classes.formInput}
          autoComplete="off"
          placeholder="Enter AWB / Reference No. number "
        />
      </Form.Item>
    );
  };

  const renderStatusTag = (status: any) => {
    if (status === 'PENDING') {
      return <Tag className={classes.pendingTag}>Pending</Tag>;
    }
    if (status === 'AWAITED') {
      return <Tag className={classes.pendingTag}>Awaited</Tag>;
    }
    if (status === 'payment_awaited') {
      return <Tag className={classes.pendingTag}>Payment Awaited</Tag>;
    }
    return <Tag className={classes.successTag}>Paid</Tag>;
  };

  const handleEditDetails = () => {
    setIsEditDetailsModalOpen(true);
    setIsLocationChange(false);
  };


  const renderSenderDetails = () => {
    const senderDetails = originDetailsData;

    return (
      <Card
        className={classes.detailsCard}
        title="Sender Details"
        size="small"
        headStyle={{ padding: '10px 15px', fontSize: '14px', fontWeight: 'bold' }}
        bodyStyle={{ padding: '10px 15px', minHeight: '210px' }}
      >
        <Row gutter={[16, 8]}>
          <Col span={8}>
            <div className={classes.infoLabel}>Name</div>
            <div className={classes.infoValue}>{senderDetails.Name}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>Phone</div>
            <div className={classes.infoValue}>{senderDetails.Phone}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>Email</div>
            <div className={classes.infoValue}>{senderDetails.Email}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>City</div>
            <div className={classes.infoValue}>{senderDetails.City}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>Pincode</div>
            <div className={classes.infoValue}>{senderDetails.Pincode}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>State</div>
            <div className={classes.infoValue}>{senderDetails.State}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>Country</div>
            <div className={classes.infoValue}>{senderDetails.Country}</div>
          </Col>
          <Col span={16}>
            <div className={classes.infoLabel}>Address</div>
            <div className={classes.infoValue} style={{ fontSize: '12px' }}>
              {senderDetails.AddressLine1}
              {' '}
              {senderDetails.AddressLine2}
            </div>
          </Col>
        </Row>
      </Card>
    );
  };



  const renderDestinationDetails = () => {
    const destinationDetails = destinationDetailsData;

    return (
      <Card
        className={classes.detailsCard}
        title="Destination Details"
        size="small"
        headStyle={{ padding: '10px 15px', fontSize: '14px', fontWeight: 'bold' }}
        bodyStyle={{ padding: '10px 15px' }}
      >
        <Row gutter={[16, 8]}>
          <Col span={8}>
            <div className={classes.infoLabel}>Name</div>
            <div className={classes.infoValue} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {destinationDetails.Name}
              {' '}
              {destinationDetails.previousName
                && destinationDetails.Name !== destinationDetails.previousName && (
                  <Tooltip title={`Updated Name: ${destinationDetails.previousName} → ${destinationDetails.Name}`}>
                    <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer', marginLeft: '5px' }} />
                  </Tooltip>
              )}
            </div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>Phone</div>
            <div className={classes.infoValue}>{destinationDetails.Phone}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>Email</div>
            <div className={classes.infoValue}>{destinationDetails.Email}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>City</div>
            <div className={classes.infoValue}>{destinationDetails.City}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>Pincode</div>
            <div className={classes.infoValue}>
              {destinationDetails.Pincode}
              {destinationDetails.previousPincode
                && destinationDetails.Pincode !== destinationDetails.previousPincode && (
                  <Tooltip title={`Updated Pincode: ${destinationDetails.previousPincode} → ${destinationDetails.Pincode}`}>
                    <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer', marginLeft: '5px' }} />
                  </Tooltip>
              )}
            </div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>State</div>
            <div className={classes.infoValue}>{destinationDetails.State}</div>
          </Col>
          <Col span={8}>
            <div className={classes.infoLabel}>Country</div>
            <div className={classes.infoValue}>{destinationDetails.Country}</div>
          </Col>
          <Col span={16}>
            <div className={classes.infoLabel}>Address</div>
            <div
              className={classes.infoValue}
              style={{
                fontSize: '12px',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            >
              {destinationDetails.AddressLine1}
              {destinationDetails.previousAddressLine1
                && destinationDetails.AddressLine1 !== destinationDetails.previousAddressLine1 && (
                  <Tooltip title={`Updated Address Line 1: ${destinationDetails.previousAddressLine1} → ${destinationDetails.AddressLine1}${destinationDetails.previousAddressLine2 ? `\nPrevious Address Line 2: ${destinationDetails.previousAddressLine2}` : ''}`}>
                    <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer', marginLeft: '5px' }} />
                  </Tooltip>
              )}
              {destinationDetails.AddressLine2 && (
                <>
                  <br />
                  {destinationDetails.AddressLine2}
                </>
              )}
            </div>
          </Col>
        </Row>
      </Card>
    );
  };

  const recalcWeightMismatchAfterEdit = async (): Promise<number | null> => {
    const referenceNumber = refNum || dropOffFormData.referenceNumber;
    if (!referenceNumber) return null;

    const weightKg = shipmentDetails.weightMismatchWeight || shipmentDetails.originalWeight;
    const length = shipmentDetails.weightMismatchLength || shipmentDetails.originalLength;
    const breadth = shipmentDetails.weightMismatchWidth || shipmentDetails.originalWidth;
    const height = shipmentDetails.weightMismatchHeight || shipmentDetails.originalHeight;

    setModalLoading(true);
    const body = {
      consignments: [
        {
          reference_number: referenceNumber,
          weight: weightKg * 1000, // API expects grams
          height: `${height}`,
          length: `${length}`,
          width: `${breadth}`,
        },
      ],
    };
    const res = await getWeightMismatchSubmit(body);
    setModalLoading(false);

    if (!res.isSuccess) {
      message.error(res.errorMessage || res.error?.message);
      return null;
    }

    const result = res.data;
    const newAmount = result?.amount || 0;
    setDifferentialCost(newAmount);
    setShowDifferntialCost(!!newAmount);

    if (consignmentPaymentStatus === 'none') {
      if (result?.proceedBooking) {
        SetShowPaymentStatus('NOT REQUIRED');
        setisPaymentAwaited(false);
      } else {
        SetShowPaymentStatus('AWAITED');
        setisPaymentAwaited(true);
      }
    }
    return newAmount;
  };

  const getPaymentLinkContact = () => {
    const email = consignmentEmail?.trim();
    const phoneNumber = consignmentphone?.trim();
    if (!email || !phoneNumber) return null;
    return { email, phoneNumber };
  };

  const sendWeightMismatchPaymentLinkAuto = async (referenceNumber: string) => {
    const contact = getPaymentLinkContact();
    if (!contact) {
      // Without contact details we can't send the payment link automatically.
      // Open the contact-details modal so the operator can enter phone/email and send.
      setcommunicationModalTitle('WEIGHT MISMATCH');
      setPaymentLinkButtonText('Send Payment Link');
      setisPaymentAwaited(true);
      setIsCommunicationModal(true);
      message.info('Please enter Email & Phone to send payment link');
      return { ok: false, reason: 'missing_contact' as const };
    }

    const body = {
      consignments: [referenceNumber],
      email: contact.email,
      phone: contact.phoneNumber,
    };

    const res = await weightMismatchPaymentLink(body as any);
    if (res?.isSuccess) {
      const result = res.data;
      if (result?.proceedBooking) {
        SetShowPaymentStatus('SUCCESS');
      } else {
        SetShowPaymentStatus('AWAITED');
      }
      setPaymentLinkButtonText('Resend Payment Link');
    }
    return { ok: !!res?.isSuccess, res };
  };


  const setDropOffComponent = (dropoff:boolean, valid:boolean, invalid:boolean) => {
    setShowDropoffDetails(dropoff);
    setShowValidDropoff(valid);
    setShowInvalidDropoff(invalid);
  };

  const handleVerifyDropoff = async (refNo: string, validationcode: string,
    isComp: boolean, isCashPayment : boolean, isInternational : boolean,
    sendDropoffPaymentLink : boolean, allowDropoff?: boolean) => {
    const storage = window.localStorage;

    if (!isComp) {
      setDropOffFormData({
        ...dropOffFormData,
        referenceNumber: refNo,
        validationCode: validationcode,
      });
    }

    const body:DropOffPayload = {
      allowDropoff: allowDropoff || false,
      referenceNumber: refNo,
      validationCode: validationcode,
      hubCode: storage.getItem('hubCode') || '',
      hubType: storage.getItem('source') || '',
      isCompletionRequest: isComp || false,
      isCashPayment: isCashPayment || false,
      isInternational: isInternational || false,
      phone: consignmentphone,
      email: consignmentEmail,
      sendDropoffPaymentLink: sendDropoffPaymentLink || false,
      hubPincode: window.localStorage.getItem('pincode') || '',
    };

    const res = await verifyDropoff(body);

    if (res.isSuccess) {
      setLoading(false);
      setCollectionLoading(false);
      if (res.data.isSuccess && res.data?.openAlertModal) {
        setIsAlertModalOpen(true);
        setRefNum(res.data?.referenceNumber);
      } else if (res.data && res.data.details && res.data.details.consignmentDetails && res.data.details.consignmentDetails.booking_status === 'cancelled') {
        setDropOffMessage('The Drop Off has been Cancelled');
        setDropOffComponent(false, false, true);
      } else {
        const ConsignmentDetails = res?.data?.details?.consignmentDetails;
        const PaymentDetails = res?.data?.details?.paymentDetails;
        const destinationDetails = res?.data?.details?.destinationDetails;
        const originDetails = res?.data?.details?.consignmentDetails?.originDetails;
        setReferenceNum(res.data?.referenceNumber);
        setRefNum(res?.data?.details?.consignmentDetails?.referenceNumber ?? '');
        if (PaymentDetails) {
          setPaymentMode(PaymentDetails?.modeOfPayment);
          if (PaymentDetails?.paymentStatus === 'success') {
            SetShowPaymentStatus('PAID');
          }
          setTariffCharges(PaymentDetails?.tariffCharges);
          setPaymentAmountPending(PaymentDetails?.amountToPay);
          setDifferentialCost(PaymentDetails?.weightMismatchDiffPrice);
          setEditDetailsAmount(PaymentDetails?.editShipmentDetailsAmount);
          setLocationChangeAmount(PaymentDetails?.locationChangeAmount);
          if (PaymentDetails?.paymentStatus === 'payment_awaited') {
            setConsignmentPaymentStatus('PENDING');
            SetShowPaymentStatus('PENDING');
            setPackagingAmount(PaymentDetails?.packagingCharges);
          }
        }
        if (ConsignmentDetails) {
          setVerifiedConsignmentDetails(ConsignmentDetails);
          setLocationChangeStatus(ConsignmentDetails?.locationChangeStatus);
          setShipmentChangeStatus(ConsignmentDetails?.shipmentChangeStatus);
          if (PaymentDetails?.modeOfPayment !== 'CASH') {
            if (ConsignmentDetails?.isCashToOnlineDropoff) {
              setPaymentAmountPending(PaymentDetails?.amountToPay);
              setIsDropoffPaymentLinkSent(true);
              setEditDetailsAmount(PaymentDetails?.editShipmentDetailsAmount);
              setLocationChangeAmount(PaymentDetails?.locationChangeAmount);
              if (ConsignmentDetails?.proceedBooking) {
                setConsignmentPaymentStatus('SUCCESS');
              } else if (!ConsignmentDetails?.proceedBooking) {
                setConsignmentPaymentStatus('AWAITED');
              }
            } else if (ConsignmentDetails?.isWeightMismatch) {
              if (ConsignmentDetails?.proceedBooking) {
                SetShowPaymentStatus('SUCCESS');
              } else if (!ConsignmentDetails?.proceedBooking) {
                SetShowPaymentStatus('AWAITED');
              }
            }
          }
          setShipmentDetails({
            bookingDate: moment(ConsignmentDetails?.creationDetails).format('lll'),
            serviceType: ConsignmentDetails?.serviceType,
            riskSurcharge: ConsignmentDetails?.riskSurchargeamount,
            loadType: ConsignmentDetails?.loadType,
            content: ConsignmentDetails?.commodityName,
            shipAssure: ConsignmentDetails?.shipAssure ? 'YES' : 'NO',
            originalWeight: ConsignmentDetails?.chargeableWeight,
            previousServiceType: ConsignmentDetails?.previousServiceTypeId,
            previousCommodity: ConsignmentDetails?.previousCommodityId,
            originalDimension: ConsignmentDetails?.originalDimension,
            originalLength: ConsignmentDetails?.length,
            originalWidth: ConsignmentDetails?.width,
            originalHeight: ConsignmentDetails?.height,
            weightMismatchWeight: ConsignmentDetails?.weightMismatchWeight,
            weightMismatchLength: ConsignmentDetails?.weightMismatchVolume
              ? ConsignmentDetails?.weightMismatchVolume.length
              : 0,
            weightMismatchHeight: ConsignmentDetails?.weightMismatchVolume
              ? ConsignmentDetails?.weightMismatchVolume.height
              : 0,
            weightMismatchWidth: ConsignmentDetails?.weightMismatchVolume
              ? ConsignmentDetails?.weightMismatchVolume.width
              : 0,
            declaredValue: ConsignmentDetails?.declaredValue,
          });
          setIsFullPageModalOpen(true);
          setconsignmentphone(ConsignmentDetails?.originDetails?.phone);
          setConsignmentEmail(ConsignmentDetails?.originDetails?.email);
        }
        if (destinationDetails) {
          setEditDetailsFormData({
            contentType: ConsignmentDetails?.contentType,
            serviceType: ConsignmentDetails?.serviceType,
            destinationName: destinationDetails?.name,
            destinationAddressLine1: destinationDetails?.addressLine1,
            destinationAddressLine2: destinationDetails?.addressLine2,
            destinationPincode: destinationDetails?.pincode,
          });

          setDestinationDetailsData({
            Name: destinationDetails?.name,
            Phone: destinationDetails?.phone,
            Email: destinationDetails?.email,
            City: destinationDetails?.city,
            Pincode: destinationDetails?.pincode,
            State: destinationDetails?.state,
            Country: destinationDetails?.country,
            AddressLine1: destinationDetails?.addressLine1,
            AddressLine2: destinationDetails?.addressLine2,
            previousName: destinationDetails?.previousDestinationName,
            previousPincode: destinationDetails?.previousDestinationPincode,
            previousAddressLine1: destinationDetails?.previousDestinationAddressLine1,
            previousAddressLine2: destinationDetails?.previousDestinationAddressLine2,
          });
        }
        if (originDetails) {
          setOriginDetailsData({
            Name: originDetails?.name,
            Phone: originDetails?.phone,
            Email: originDetails?.email,
            City: originDetails?.city,
            Pincode: originDetails?.pincode,
            State: originDetails?.state,
            Country: originDetails?.country,
            AddressLine1: originDetails?.addressLine1,
            AddressLine2: originDetails?.addressLine2,
          });
        }
        if (PaymentDetails?.locationChangeAmount && PaymentDetails?.modeOfPayment !== 'CASH' && locationChangeStatus === 'PENDING' && !ConsignmentDetails.isCashToOnlineDropoff) {
          setAmountToShow(PaymentDetails?.locationChangeAmount);
          setIsLocationChange(true);
          setIsPaymentModalOpen(true);
        }
        setAmountToShow(PaymentDetails?.locationChangeAmount);
        setIsInternational(ConsignmentDetails?.isInternational ?? false);
        const dropoff_data = lodash.size(res.data.details);
        if (dropoff_data > 0) {
          setDropOffDetailsData(res.data.details);
          setDropOffComponent(true, false, false);
        } else {
          setDropOffMessage(res.data.message);
          setDropOffComponent(false, true, false);
        }
      }
    } else {
      message.error(res.errorMessage);
      setLoading(false);
      setCollectionLoading(false);
    }
  };

  const handlePaymentLinkSent = async () => {
    // Handle sequential payment links for edit details and location change (online)
    if (!isLocationChange && paymentMode !== 'CASH') {
      if (locationPaymentQueuedAfterEdit && locationChangeAmount > 0) {
        // Open location change payment modal after edit details payment link
        setLocationPaymentQueuedAfterEdit(false);
        setAmountToShow(locationChangeAmount);
        setIsLocationChange(true);
        setIsPaymentModalOpen(true);
        return;
      }
      await handleVerifyDropoff(refNum, lastDropOffCode, false,
        false, isInternationalConsignment, false);
      await recalcWeightMismatchAfterEdit();
      await handleVerifyDropoff(refNum, lastDropOffCode, false,
        false, isInternationalConsignment, false);
      // Reload dropoff details to reflect updated payment status
    } else if (isLocationChange && paymentMode !== 'CASH') {
      if (shouldRecalcAfterLocationPayment) {
        await recalcWeightMismatchAfterEdit();
        setShouldRecalcAfterLocationPayment(false);
      }
      // After location change payment link is sent, reload dropoff details
      handleVerifyDropoff(refNum, lastDropOffCode, false,
        false, isInternationalConsignment, false);
    }
  };

  const renderPaymentModal = () => {
    return (
      <PaymentModal
        consignments={refNum}
        setIsPaymentModalOpen={setIsPaymentModalOpen}
        isOpen={isPaymentModalOpen}
        isLocationChange={isLocationChange}
        loading={loading}
        amountToShow={amountToShow}
        onPaymentLinkSent={handlePaymentLinkSent}
      />
    );
  };


  React.useEffect(() => {
    if (isEditDetailsModalOpen) {
      // Setting initial form values when modal opens
      const initialValues = {
        contentType: shipmentDetails.content,
        serviceType: shipmentDetails.serviceType,
        destinationName: destinationDetailsData.Name,
        destinationAddressLine1: destinationDetailsData.AddressLine1,
        destinationAddressLine2: destinationDetailsData.AddressLine2,
        destinationPincode: destinationDetailsData.Pincode,
      };

      form.setFieldsValue(initialValues);

      // Also update state
      setEditDetailsFormData(initialValues);
    }
  }, [isEditDetailsModalOpen, form]);

  React.useEffect(() => {
    if (isEditDetailsModalOpen) {
      // Setting initial form values when modal opens
      form.setFieldsValue(editDetailsFormData);
    }
  }, [isEditDetailsModalOpen, editDetailsFormData, form]);

  const fetchCommodityData = async () => {
    const apiBody = {
      bookingType: isInternationalConsignment ? 'INTERNATIONAL' : 'DOMESTIC',
    };
    const res = await getCommodityData(apiBody);
    if (res.isSuccess) {
      const formattedData = res.data.map((item: any) => ({
        value: item.COMMODITY_ID,
        label: item.COMMODITY_NAME,
      }));
      setContentTypes(formattedData);
    }
  };

  React.useEffect(() => {
    if (isEditDetailsModalOpen) {
      fetchCommodityData();
    }
  }, [isEditDetailsModalOpen]);


  const createApiBody = () => {
    const formValues = form.getFieldsValue();
    const isDocument = shipmentDetails.loadType === 'DOCUMENT';
    const baseBody = {
      pickupPincode: originDetailsData.Pincode,
      deliveryPincode: formValues.destinationPincode || destinationDetailsData.Pincode,
      srcCity: originDetailsData.City,
      srcState: originDetailsData.State,
      destCity: destinationDetailsData.City,
      destState: destinationDetailsData.State,
      deliveryCountry: destinationDetailsData.Country,
      weight: shipmentDetails.originalWeight * 1000,
      courierType: isDocument ? 'Document' : 'Non-Document',
    };

    if (isDocument) {
      return {
        ...baseBody,
        isQRBooking: false,
      };
    }
    if (isInternationalConsignment) {
      return {
        ...baseBody,
        id: 'ebookingInt',
      };
    }
    const selectedCommodity = contentTypes.find((item) => item.value === formValues.contentType)
      || { value: '', label: '' };

    return {
      ...baseBody,
      length: shipmentDetails.originalLength,
      breadth: shipmentDetails.originalWidth,
      height: shipmentDetails.originalHeight,
      commodityId: selectedCommodity.value,
      commodityName: selectedCommodity.label,
      declaredPrice: shipmentDetails.declaredValue,
    };
  };

  const validatePincode = (pincode: string) => {
    if (!pincode) return false;

    if (isInternationalConsignment) {
      const internationalPattern = /^[A-Za-z0-9\s-]{2,10}$/;
      return internationalPattern.test(pincode);
    }
    const indianPattern = /^[1-9][0-9]{5}$/;
    return indianPattern.test(pincode);
  };

  const fetchPriceAndTat = async () => {
    const pincode = form.getFieldValue('destinationPincode');

    if (!validatePincode(pincode)) {
      return;
    }

    const apiBody = createApiBody();
    let res;
    if (isInternationalConsignment) {
      res = await getPriceAndTatInternational(apiBody);
    } else {
      res = await getPriceAndTat(apiBody);
    }
    if (res && res.isSuccess) {
      setServiceTypes(res.data);
    }
  };

  React.useEffect(() => {
    if (isEditDetailsModalOpen) {
      fetchPriceAndTat();
    }
  }, [isEditDetailsModalOpen, form.getFieldValue('destinationPincode'), form.getFieldValue('contentType')]);


  const handleFormChange = (changedValues: any) => {
    setEditDetailsFormData({
      ...editDetailsFormData,
      ...changedValues,
    });
  };


  const resendDropoffSMS = async () => {
    const referenceNumber = form.getFieldsValue().referencenumber;
    const username = window.localStorage.getItem('username');

    setLoading(true);
    const res = await resendSMS({ referenceNumber, username });
    if (res.isSuccess) {
      message.success('Drop-off Code has been successfully sent');
    } else {
      message.error(res.errorMessage);
    }
    setLoading(false);
  };

  const renderDropoffCode = () => {
    return (
      <Form.Item
        name="validationcode"
        label={(
          <div>
            <span>Enter Drop Off Code</span>
            <span className={classes.resendDropoffCode} onClick={resendDropoffSMS}>
              Resend Drop-off Code
            </span>
          </div>
        )}
        className={classes.formLabel}
        colon={false}
        rules={[{
          required: true,
          message: 'Drop off code is required',
        }]}
      >
        <Input
          className={classes.formInput}
          autoComplete="off"
          placeholder="Enter Drop Off Code"
        />
      </Form.Item>
    );
  };

  const renderSubmitButton = () => {
    return (
      <Form.Item>
        <Button
          className={classes.submitButton}
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={loading}
        >
          Check
        </Button>
      </Form.Item>
    );
  };


  const handleDropoffSubmit = async (values: { referencenumber: string,
    validationcode: string, isInternational : boolean }) => {
    setShowDropoffDetails(false);
    const { referencenumber, validationcode, isInternational } = values;
    SetShowPaymentStatus('none');
    setConsignmentPaymentStatus('none');
    setLastDropOffCode(validationcode);
    setShowDifferntialCost(false);
    setisPaymentAwaited(false);
    setIsDropoffPaymentLinkSent(false);
    setLoading(true);
    handleVerifyDropoff(referencenumber as string, validationcode as string,
      false, false, isInternational, false);
    form.resetFields();
  };

  const handleSubmit = async () => {
    setLoading(true);
    setLocationPaymentQueuedAfterEdit(false);
    setShouldRecalcAfterLocationPayment(false);
    const formValues = form.getFieldsValue();
    // Check if pincode has changed
    const isPincodeChanged = formValues.destinationPincode !== destinationDetailsData.Pincode;
    const isNameChanged = formValues.destinationName !== destinationDetailsData.Name;
    const isAddressLine1Changed = formValues.destinationAddressLine1
    !== destinationDetailsData.AddressLine1;
    const isAddressLine2Changed = formValues.destinationAddressLine2
    !== destinationDetailsData.AddressLine2;

    const selectedServiceType = serviceTypes.find(
      (type) => type.serviceType === formValues.serviceType,
    );

    const selectedContentType = contentTypes.find(
      (type) => type.value === formValues.contentType,
    ) || { value: '', label: '' };

    const apiBody = {
      reference_number: refNum,
      isInternational: isInternationalConsignment,
      paymentMode,
      contentTypeId: selectedContentType.value,
      contentTypeName: selectedContentType.label,
      signature: selectedServiceType?.hash,
      serviceType: selectedServiceType?.serviceType, // Get the service type name before the price
      serviceTypePrice: selectedServiceType?.price,
      destinationName: formValues.destinationName,
      destinationAddressLine1: formValues.destinationAddressLine1,
      destinationAddressLine2: formValues.destinationAddressLine2,
      destinationPincode: formValues.destinationPincode,
      previousDestinationPincode: destinationDetailsData.Pincode,
      changePincode: isPincodeChanged,
      previousDestinationName: isNameChanged ? destinationDetailsData.Name : null,
      previousDestinationAddressLine1:
      isAddressLine1Changed ? destinationDetailsData.AddressLine1 : null,
      previousDestinationAddressLine2:
      isAddressLine2Changed ? destinationDetailsData.AddressLine2 : null,
    };

    const res = await editShipmentDetails(apiBody);
    if (res.isSuccess) {
      const Data = res?.data;
      message.success('Shipment details updated successfully');

      const hasLocationChangeAmount = !!Data.locationChangeAmount;
      const hasEditDetailsAmount = !!Data.editDetailsAmount;

      if (hasLocationChangeAmount) {
        setLocationChangeAmount(Data.locationChangeAmount);
      }
      if (hasEditDetailsAmount) {
        setEditDetailsAmount(Data.editDetailsAmount);
      }

      const shouldTriggerPaymentLink = paymentMode !== 'CASH' && (hasEditDetailsAmount || hasLocationChangeAmount);

      if (shouldTriggerPaymentLink) {
        if (hasEditDetailsAmount) {
          setAmountToShow(Data.editDetailsAmount);
          setIsLocationChange(false);
          setIsPaymentModalOpen(true);
          if (hasLocationChangeAmount) {
            // Queue location change payment after edit details payment link is sent
            setLocationPaymentQueuedAfterEdit(true);
            setShouldRecalcAfterLocationPayment(true);
          }
        } else if (hasLocationChangeAmount) {
          setAmountToShow(Data.locationChangeAmount);
          setIsLocationChange(true);
          setIsPaymentModalOpen(true);
        }
      }

      // Refresh dropoff details when no payment link is required (zero amounts) or for cash
      if (paymentMode !== 'CASH' || !shouldTriggerPaymentLink) {
        // await handleVerifyDropoff(refNum, lastDropOffCode, false,
        //   false, isInternationalConsignment, false);
        const newWeightMismatchAmount = await recalcWeightMismatchAfterEdit();
        const shouldResendWeightMismatch = newWeightMismatchAmount
        && newWeightMismatchAmount !== differentialCost;
        if (shouldResendWeightMismatch) {
          await sendWeightMismatchPaymentLinkAuto(refNum);
        }

        // await handleVerifyDropoff(refNum, lastDropOffCode, false,
        //   false, isInternationalConsignment, false);
      }
    } else {
      message.error(res.errorMessage);
    }
    setIsEditDetailsModalOpen(false);
    setLoading(false);
  };


  const initialValues = editDetailsFormData;
  const renderEditDetailsModal = () => {
    return (
      <Modal
        open={isEditDetailsModalOpen}
        onCancel={() => setIsEditDetailsModalOpen(false)}
        footer={null}
        closable={false}
        width={520}
        bodyStyle={{ padding: 0, maxHeight: '100vh', overflowY: 'auto' }}
        title={null}
        style={{ top: 20 }}
      >
        {/* Custom Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 24px',
          borderBottom: '1px solid #f0f0f0',
        }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CloseOutlined
              onClick={() => setIsEditDetailsModalOpen(false)}
              style={{ fontSize: '18px', marginRight: '12px', cursor: 'pointer' }}
            />
            <Typography.Text strong style={{ fontSize: '18px' }}>
              Edit Details
            </Typography.Text>
          </div>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
            size="large"
            disabled={!isServiceTypeValid || (paymentMode !== 'CASH' && form.getFieldValue('serviceType') !== shipmentDetails.serviceType)}
            style={{
              marginLeft: 'auto',
              backgroundColor: '#4096FF',
              height: '40px',
              fontSize: '16px',
              borderRadius: '4px',
            }}
          >
            Confirm
          </Button>
        </div>

        {/* Warning Note */}
        <div style={{
          backgroundColor: '#FFF1AC',
          padding: '12px 24px',
          borderBottom: '4px solid #f0f0f0',
          fontSize: '14px',
          color: '#8C6D1F',
          fontWeight: 'normal',
          margin: '0 20px',
          marginTop: '16px',
        }}
        >
          Please note that any update in the details will incur
          additional cost that has to be settled for smooth delivery
        </div>

        {/* Form Content - Improved Layout */}
        <Form
          form={form}
          initialValues={initialValues}
          style={{ padding: '16px 24px' }}
          onValuesChange={handleFormChange}
        >
          {shipmentDetails.loadType !== 'DOCUMENT' && (
          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{
                width: '170px',
                marginRight: '15px',
                fontSize: '14px',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
              >
                Content Type :
              </label>
              <div style={{ flex: 1 }}>
                <Form.Item
                  name="contentType"
                  style={{ margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: 'Content type is required',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select content type"
                    options={contentTypes}
                    loading={loading}
                    style={{ width: '100%' }}
                    suffixIcon={<DownOutlined />}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
          )}


          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{
                width: '170px',
                marginRight: '15px',
                fontSize: '14px',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
              >
                Destination Name :
              </label>
              <div style={{ flex: 1 }}>
                <Form.Item
                  name="destinationName"
                  style={{ margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: 'Destination Name is required',
                    },
                    {
                      min: 3,
                      max: 25,
                      message: 'Destination Name must be between 3 and 25 characters',
                    },
                  ]}
                >
                  <Input placeholder="Enter destination name" />
                </Form.Item>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex' }}>
              <label style={{
                width: '170px',
                marginRight: '15px',
                fontSize: '14px',
                paddingTop: '6px',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
              >
                Destination Address
                <br />
                Line 1 :
              </label>
              <div style={{ flex: 1 }}>
                <Form.Item
                  name="destinationAddressLine1"
                  style={{ margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: 'Destination Address Line 1 is required',
                    },
                    {
                      min: 3,
                      max: 200,
                      message: 'Destination Address Line 1 must be between 3 and 200 characters',
                    },
                  ]}
                >
                  <Input.TextArea
                    placeholder="Enter address line 1"
                    style={{ height: '80px', resize: 'none' }}
                    autoSize={false}
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex' }}>
              <label style={{
                width: '170px',
                marginRight: '15px',
                fontSize: '14px',
                paddingTop: '6px',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
              >
                Destination Address
                <br />
                Line 2 :
              </label>
              <div style={{ flex: 1 }}>
                <Form.Item
                  name="destinationAddressLine2"
                  style={{ margin: 0 }}
                  rules={[
                    {
                      min: 3,
                      max: 100,
                      message: 'Destination Address Line 2 must be between 3 and 100 characters',
                    },
                  ]}
                >
                  <Input.TextArea
                    placeholder="Enter address line 2"
                    style={{ height: '80px', resize: 'none' }}
                    autoSize={false}
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{
                width: '170px',
                marginRight: '15px',
                fontSize: '14px',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
              >
                Destination Pincode :
              </label>
              <div style={{ flex: 1 }}>
                <Form.Item
                  name="destinationPincode"
                  style={{ margin: 0 }}
                  rules={[
                    {
                      required: true,
                      message: 'Destination Pincode is required',
                    },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();

                        if (isInternationalConsignment) {
                          const internationalPattern = /^[A-Za-z0-9\s-]{2,10}$/;
                          if (!internationalPattern.test(value)) {
                            return Promise.reject(new Error('Please enter a valid international postal code'));
                          }
                        } else {
                          // Indian pincode validation - 6 digits starting with 1-9
                          const indianPattern = /^[1-9][0-9]{5}$/;
                          if (!indianPattern.test(value)) {
                            return Promise.reject(new Error('Destination Pincode must be a valid 6-digit number'));
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input placeholder={isInternationalConsignment ? 'Enter postal code' : 'Enter pincode'} />
                </Form.Item>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{
                width: '170px',
                marginRight: '15px',
                fontSize: '14px',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
              >
                Service Type :
              </label>
              <div style={{ flex: 1 }}>
                <Form.Item
                  name="serviceType"
                  style={{ margin: 0 }}
                  labelCol={{ style: { paddingRight: '15px' } }}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (paymentMode !== 'CASH' && value !== shipmentDetails.serviceType) {
                          return Promise.reject(
                            new Error('Service Type change is applicable to Cash Bookings only.'),
                          );
                        }
                        if (serviceTypes.length > 0
                          && !serviceTypes.some((type) => type.serviceType === value)) {
                          if (paymentMode === 'CASH') {
                            return Promise.reject(
                              new Error('Selected service type isnt available for pincode pair. Please reselect.'),
                            );
                          }
                          return Promise.reject(
                            new Error('Selected service type isnt available for pincode pair. Please reselect.'),
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Select
                    placeholder="Select service type"
                    options={serviceTypes.map((type) => ({
                      value: type.serviceType,
                      label: `${type.serviceType} - ${type.price}`,
                    }))}
                    loading={loading}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    );
  };

  const renderPaymentInfo = () => {
    // const totalAmount
    const packagingPaymentStatus = verifiedConsignmentDetail?.packingDetails?.paymentStatus;
    let totalPendingAmount = 0;
    totalPendingAmount += ((ShowPaymentStatus === 'PENDING' || ShowPaymentStatus === 'AWAITED') && differentialCost) ? differentialCost : 0;
    totalPendingAmount += ((shipmentChangeStatus === 'PENDING' || shipmentChangeStatus === 'AWAITED') && editDetailsAmount) ? editDetailsAmount : 0;
    totalPendingAmount += ((locationChangeStatus === 'PENDING' || locationChangeStatus === 'AWAITED') && locationChangeAmount) ? locationChangeAmount : 0;
    totalPendingAmount += (packagingPaymentStatus === 'PENDING' || packagingPaymentStatus === 'AWAITED') ? verifiedConsignmentDetail?.packingDetails?.price : 0;
    totalPendingAmount += (ShowPaymentStatus === 'PENDING' && tariffCharges) ? tariffCharges : 0;
    return (
      <Card
        className={classes.detailsCard}
        size="small"
        headStyle={{ padding: '10px 15px', fontSize: '14px', fontWeight: '500' }}
        bodyStyle={{ padding: '10px 15px' }}
        title={(
          <div className={classes.cardTitle}>
            <span style={{ fontWeight: 'bold' }}>Payment Info</span>
            {totalPendingAmount > 0 ? (
              <Tag color="red" style={{ fontSize: '12px' }}>
                Payment Pending:
                {' '}
                {totalPendingAmount}
                <Tooltip title="Refresh payment status">
                  <Button
                    type="text"
                    size="small"
                    icon={<ReloadOutlined />}
                    onClick={() => handleVerifyDropoff(refNum, lastDropOffCode, false,
                      false, isInternationalConsignment, false)}
                    style={{
                      marginLeft: '5px',
                      padding: '0 2px',
                      color: '#ff4d4f',
                      height: '16px',
                      lineHeight: '16px',
                    }}
                  />
                </Tooltip>
              </Tag>
            ) : (
              <Tag color="green" style={{ fontSize: '12px' }}>
                PAID
                <Tooltip title="Refresh payment status">
                  <Button
                    type="text"
                    size="small"
                    icon={<ReloadOutlined />}
                    onClick={() => handleVerifyDropoff(refNum, lastDropOffCode, false,
                      false, isInternationalConsignment, false)}
                    style={{
                      marginLeft: '5px',
                      padding: '0 2px',
                      color: '#52c41a',
                      height: '16px',
                      lineHeight: '16px',
                    }}
                  />
                </Tooltip>
              </Tag>
            )}
          </div>
        )}
      >
        {/* Payment Mode */}
        <Row className={classes.infoRow}>
          <Col span={12}>
            <div className={classes.infoLabel}>Payment Mode</div>
          </Col>
          <Col span={12}>
            <div className={classes.infoValue}>{paymentMode === 'CASH' ? 'Cash' : 'Paid Online'}</div>
          </Col>
        </Row>

        {/* Payment Status */}
        <Row className={classes.infoRow}>
          <Col span={12}>
            <div className={classes.infoLabel}>Payment Status</div>
          </Col>
          <Col span={12}>
            <div className={classes.infoValue}>{ShowPaymentStatus}</div>
          </Col>
        </Row>

        {/* Amount */}
        <Row className={classes.infoRow}>
          <Col span={12}>
            <div className={classes.infoLabel}>Amount</div>
          </Col>
          <Col span={12}>
            <div className={classes.infoValue}>
              {' '}
              {tariffCharges}
            </div>
          </Col>
        </Row>

        {/* Weight Mismatch Amount */}
        {differentialCost ? (
          <Row className={classes.infoRow}>
            <Col span={12}>
              <div className={classes.infoLabel}>
                Weight Mismatch Amount
                {' '}
                {renderStatusTag(ShowPaymentStatus)}
              </div>
            </Col>
            <Col span={12}>
              <div className={classes.infoValue}>
                {' '}
                {differentialCost}
              </div>
            </Col>
          </Row>
        ) : null}

        {/* Shipment Details Mismatch Amount */}
        {editDetailsAmount ? (
          <Row className={classes.infoRow}>
            <Col span={12}>
              <div className={classes.infoLabel}>
                Shipment Details Mismatch Amount
                {' '}
                {renderStatusTag(shipmentChangeStatus)}
              </div>
            </Col>
            <Col span={12}>
              <div className={classes.infoValue}>
                {' '}
                {editDetailsAmount}
              </div>
            </Col>
          </Row>
        ) : null}

        {locationChangeAmount ? (
          <Row className={classes.infoRow}>
            <Col span={12}>
              <div className={classes.infoLabel}>
                location change amount
                {' '}
                {renderStatusTag(locationChangeStatus)}
              </div>
            </Col>
            <Col span={12}>
              <div className={classes.infoValue}>
                {' '}
                {locationChangeAmount}
              </div>
            </Col>
          </Row>
        ) : null}

        {/* Packaging Material Amount */}
        { verifiedConsignmentDetail?.packingDetails?.price ? (
          <Row className={classes.infoRow}>
            <Col span={12}>
              <div className={classes.infoLabel}>
                Packaging Material Amount
                {' '}
                {renderStatusTag(packagingPaymentStatus)}
              </div>
            </Col>
            <Col span={12}>
              <div className={classes.infoValue}>
                {' '}
                {verifiedConsignmentDetail?.packingDetails?.price}
              </div>
            </Col>
          </Row>
        ) : null}

        <Divider style={{ margin: '8px 0' }} />

        {/* Total Amount */}
        <Row className={classes.totalRow}>
          <Col span={12}>
            <div className={classes.infoLabel}>Total Amount</div>
          </Col>
          <Col span={12}>
            <div className={classes.infoValue}>
              {' '}
              {amountPending}
            </div>
          </Col>
        </Row>
      </Card>
    );
  };
  const renderDropOffForm = () => {
    return (
      <div className={classes.dropOffRequestForm}>
        <div className={classes.droppoffHeading}>
          Drop-Off Details
        </div>
        <div className={classes.dropoffForm}>
          <Form
            form={form}
            wrapperCol={{ span: 20 }}
            onFinish={handleDropoffSubmit}
          >
            {renderConsignmentNumber()}
            {renderDropoffCode()}
            {renderSubmitButton()}
          </Form>
        </div>
      </div>
    );
  };

  const handleReloadDropOff = () => {
    handleDropoffSubmit({
      referencenumber: verifiedConsignmentDetail?.referenceNumber,
      validationcode: lastDropOffCode,
      isInternational: isInternationalConsignment,
    });
  };

  const handleClearDropoff = () => {
    setIsFullPageModalOpen(false);
    setDropOffComponent(false, false, false);
    form.resetFields();
  };

  const renderOkayButton = () => {
    return (
      <Button
        className={classes.okayButton}
        type="primary"
        htmlType="submit"
        onClick={handleClearDropoff}
      >
        Okay
      </Button>
    );
  };

  const renderDetailsHeading = () => {
    return (
      <>
        <div className={classes.consignmentNumberHeading}>
          <span>
            {`CN# - ${dropOffFormData.referenceNumber}`}
          </span>
          <span style={{ marginLeft: '5px' }}>
            { `| Drop off code - ${dropOffFormData.validationCode}` }
          </span>
        </div>
        <hr className={classes.lineBreakStyle} />
      </>
    );
  };

  const renderValidDropOff = () => {
    return (
      <Modal
        open={showValidDropoff}
        footer={null}
        onCancel={handleClearDropoff}
        width={400}
        closable={false}
        centered
        bodyStyle={{ padding: 0 }}
      >
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '24px',
          background: '#fff',
        }}
        >
          <img
            style={{
              width: '120px',
              height: '120px',
              marginBottom: '24px',
            }}
            src={dropoff_success}
            alt="Valid Dropoff"
          />
          <div style={{
            fontSize: '16px',
            textAlign: 'center',
            marginBottom: '24px',
            color: '#333',
          }}
          >
            {dropOffMessage}
            <br />
            {referenceNum !== '' ? referenceNum : <></>}
          </div>
          <Button
            type="primary"
            onClick={handleClearDropoff}
            style={{
              minWidth: '120px',
              height: '40px',
              fontSize: '16px',
            }}
          >
            Okay
          </Button>
        </div>
      </Modal>
    );
  };

  const handleRequestCompletion = async () => {
    if (consignmentPaymentStatus === 'PENDING') {
      setCollectCashModalOpen(true);
    } else {
      setCollectionLoading(true);
      const { referenceNumber, validationCode } = dropOffFormData;
      handleVerifyDropoff(referenceNumber as string, validationCode as string,
        true, false, isInternationalConsignment, false);
      form.resetFields();
    }
  };

  const renderCollectionButton = () => {
    const paymentAwaitingStatuses = ['AWAITED', 'PENDING', 'payment_awaited'];
    const weightMismatchPaymentPending = paymentAwaitingStatuses.includes(ShowPaymentStatus)
      && differentialCost !== 0;
    const paymentCheck = paymentAwaitingStatuses.includes(consignmentPaymentStatus)
    || (paymentAwaitingStatuses.includes(locationChangeStatus) && locationChangeAmount !== 0)
    || (paymentAwaitingStatuses.includes(shipmentChangeStatus) && editDetailsAmount !== 0)
    || weightMismatchPaymentPending;
    const buttonClass = paymentCheck && !(paymentMode === 'CASH')
      ? `${classes.collectionButton} ${classes.disabledButton}`
      : classes.collectionButton;
    if (paymentCheck && !(paymentMode === 'CASH')) {
      return (
        <Tooltip title={collectionCompleteDiableText}>
          <div className={classes.disabledCollectionButton}>

            <span>
              Collection Complete
            </span>

          </div>
        </Tooltip>
      );
    }
    return (
      <div className={classes.collectionButtonDiv}>
        <Button
          className={buttonClass}
          onClick={handleRequestCompletion}
          type="primary"
          htmlType="submit"
          loading={collectionLoading}
          disabled={consignmentPaymentStatus === 'AWAITED'}
        >
          Collection Complete
        </Button>
      </div>
    );
  };

  const getWeightMismatchData = async (referenceNumber: string) => {
    const body = {
      consignments: [
        referenceNumber,
      ],
    };
    const res = await weightMismatchValues(body);
    setModalLoading(false);
    if (res.isSuccess) {
      const result = res.data[0];
      seteditingWeightmismatch(result);
      if (result.isEditable) {
        setIsWeightMismatchDisabled(false);
      } else {
        setIsWeightMismatchDisabled(true);
      }
      if (consignmentPaymentStatus === 'none') {
        if (result.online_payment_status === 'AWAITED') {
          SetShowPaymentStatus('AWAITED');
          setisPaymentAwaited(true);
          setPaymentLinkButtonText('Resend Payment Link');
        } else if (result.online_payment_status === 'SUCCESS' || result.online_payment_status === 'NOT REQUIRED') {
          SetShowPaymentStatus(result.online_payment_status);
        }
      }
      if (result.email) {
        setConsignmentEmail(result.email);
      }
      if (result.phone) {
        setconsignmentphone(result.phone);
      }
    } else {
      message.error(res.errorMessage || res.error.message);
      setIsWeightMismatchDisabled(false);
    }
  };

  const showModalWeightMismatch = () => {
    setIsModalOpen(true);
    setModalLoading(true);
    setVisiblePaymentStatus(true);
    const packageResponse = dropOffDetailsData?.consignmentDetails;

    const detailsForWeightmismatch = [{
      id: 1,
      referenceNumber: packageResponse?.referenceNumber,
      weight: packageResponse?.chargeableWeight,
      length: packageResponse?.length || 0,
      breadth: packageResponse?.width || 0,
      height: packageResponse?.height || 0,
    }];
    getWeightMismatchData(packageResponse?.referenceNumber as string);
    setDataSource(detailsForWeightmismatch);
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setVisibleSubmitButton(false);
    if (consignmentPaymentStatus !== 'none') {
      handleReloadDropOff();
    }
  };
  const handleCommunicationModalCancel = () => {
    setIsCommunicationModal(false);
    setVisibleSubmitButton(false);
    setIsCashToOnlineDropoff(false);
  };
  const RenderWeightmismatchButton = () => {
    const disableWeightMismatch = isDropoffPaymentLinkSent;
    const buttonClass = disableWeightMismatch
      ? `${classes.editDetailsButton} ${classes.disabledButton}`
      : classes.editDetailsButton;
    return (
      <FormItem>
        <Button
          className={buttonClass}
          type="primary"
          htmlType="submit"
          disabled={disableWeightMismatch}
          onClick={showModalWeightMismatch}
        >
          Weight Mismatch
        </Button>
      </FormItem>
    );
  };


  const renderShipmentInfo = () => {
    const originalVolume = shipmentDetails.originalLength * shipmentDetails.originalWidth
    * shipmentDetails.originalHeight || 0;
    const weightMismatchVolume = shipmentDetails.weightMismatchLength
    * shipmentDetails.weightMismatchWidth * shipmentDetails.weightMismatchHeight || 0;
    const paymentAwaitingStatuses = ['AWAITED', 'PENDING', 'payment_awaited'];
    const locationChangePaymentDone = locationChangeStatus !== 'none'
      && locationChangeAmount !== 0
      && !paymentAwaitingStatuses.includes(locationChangeStatus);
    const shipmentChangePaymentDone = shipmentChangeStatus !== 'none'
      && editDetailsAmount !== 0
      && !paymentAwaitingStatuses.includes(shipmentChangeStatus);
    const weightMismatchPaymentDone = differentialCost > 0
      && !paymentAwaitingStatuses.includes(ShowPaymentStatus);
    const paymentAlreadyDone = locationChangePaymentDone
      || shipmentChangePaymentDone
      || weightMismatchPaymentDone;
    return (
      <Card className={classes.shipmentCard} bodyStyle={{ padding: 0 }}>
        <div className={classes.shipmentHeader}>
          <Row gutter={8} align="middle">
            <Col span={16}>
              <div className={classes.shipmentTitle}>
                Shipment#
                {' '}
                {refNum}
              </div>
            </Col>
            <Col span={8}>
              <div className={classes.shipmentActions}>
                {RenderWeightmismatchButton()}
                <div className={classes.divider} />
                <Button
                  className={(isDropoffPaymentLinkSent || paymentAlreadyDone)
                    ? `${classes.editDetailsButton} ${classes.disabledButton}`
                    : classes.editDetailsButton}
                  size="small"
                  type="primary"
                  disabled={(isDropoffPaymentLinkSent || paymentAlreadyDone)}
                  onClick={() => handleEditDetails()}
                >
                  Edit Details
                </Button>
              </div>
            </Col>
          </Row>
        </div>
        <div className={classes.infoGrid}>
          <Row gutter={[16, 8]}>
            <Col span={4}>
              <div className={classes.infoLabel}>Service Type</div>
              <div className={classes.infoValue}>
                {shipmentDetails.serviceType}
                {' '}
                {shipmentDetails.previousServiceType
                && shipmentDetails.serviceType !== shipmentDetails.previousServiceType && (
                <Tooltip title={`Updated Service Type: ${shipmentDetails.previousServiceType} → ${shipmentDetails.serviceType}`}>
                  <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer', marginLeft: '5px' }} />
                </Tooltip>
                )}
              </div>
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Booking Date</div>
              <div className={classes.infoValue}>{shipmentDetails.bookingDate}</div>
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Risk Surcharge</div>
              <div className={classes.infoValue}>{shipmentDetails.riskSurcharge}</div>
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Load Type</div>
              <div className={classes.infoValue}>{shipmentDetails.loadType}</div>
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Content</div>
              <div className={classes.infoValue}>
                {shipmentDetails.content}
                {' '}
                {shipmentDetails.previousCommodity && (
                <Tooltip title={`Previous Content Type: ${shipmentDetails.previousCommodity}`}>
                  <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                </Tooltip>
                )}
              </div>
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Ship Assure</div>
              <div className={classes.infoValue}>{shipmentDetails.shipAssure}</div>
            </Col>
          </Row>

          <Divider style={{ margin: '8px 0' }} />

          <Row gutter={[16, 8]}>
            <Col span={4}>
              <div className={classes.infoLabel}>Original Weight (Kgs)</div>
              <div className={classes.infoValue}>{shipmentDetails.originalWeight}</div>
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Original Dimension</div>
              {shipmentDetails.originalLength && shipmentDetails.originalWidth
              && shipmentDetails.originalHeight && (
              <div className={classes.infoValue}>
                {shipmentDetails.originalLength}
                {' '}
                X
                {shipmentDetails.originalWidth}
                {' '}
                X
                {shipmentDetails.originalHeight}
              </div>
              )}
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Original Volume</div>
              <div className={classes.infoValue}>{originalVolume}</div>
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Weight Mismatch (Kgs)</div>
              <div className={classes.infoValue}>{shipmentDetails.weightMismatchWeight}</div>
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Weight Mismatch Dimension</div>
              {shipmentDetails.weightMismatchLength && (
              <div className={classes.infoValue}>
                {shipmentDetails.weightMismatchLength}
                {' '}
                X
                {shipmentDetails.weightMismatchWidth}
                {' '}
                X
                {shipmentDetails.weightMismatchHeight}
              </div>
              )}
            </Col>
            <Col span={4}>
              <div className={classes.infoLabel}>Weight Mismatch Volume</div>
              <div className={classes.infoValue}>
                {weightMismatchVolume}
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    );
  };

  const renderButtonPackageOption = () => {
    if (currentPackagingPaymentStatus === 'AWAITED'
      || currentPackagingPaymentStatus === 'COMPLETE') return null;
    const disablePackagingButton = isDropoffPaymentLinkSent;
    const buttonClass = disablePackagingButton
      ? `${classes.addPackagingButton} ${classes.disabledButton}`
      : classes.addPackagingButton;
    return (
      <FormItem>
        <Button
          className={buttonClass}
          type="default"
          htmlType="submit"
          disabled={disablePackagingButton}
          style={{
            color: '#0E2C53',
            background: 'transparent',
            borderColor: '#0E2C53',
            borderWidth: '1px',
            borderStyle: 'solid',
          }}
          onClick={() => {
            setIsPackageModalOpen(true);
          }}
        >
          Add Packaging Material
        </Button>
      </FormItem>
    );
  };

  const onEditWeightMismatch = (record: any) => {
    setIsEditing(true);
    seteditingWeightmismatch({ ...record });
    setShowDifferntialCost(false);
  };

  const handleBack = () => {
    setIsFullPageModalOpen(false);
  };

  const BackToConsignmentsButton = () => {
    return (
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={() => handleBack()}
        style={{
          fontSize: '16px',
          fontWeight: 'bold',
        }}
      >
        Back to Consignments
      </Button>
    );
  };

  const renderButtons = () => {
    return (
      <Row gutter={16} align="middle" justify="space-between">
        {/* Left aligned Back to Consignments Button */}
        <Col>
          {BackToConsignmentsButton()}
        </Col>
        <Col>
          <Row gutter={4} justify="end">
            <Col>
              {renderButtonPackageOption()}
            </Col>
            <Col>
              {renderCollectionButton()}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const cancelDimensionsModal = () => {
    setIsEditing(false);
    seteditingWeightmismatch(null);
  };
  const renderPackagingDetails = () => {
    const packagingMaterial = verifiedConsignmentDetail?.packingDetails?.packingMaterial || [];

    // Calculate total cost
    const totalCost = packagingMaterial.reduce((acc: number, item: any) => {
      return acc + (item.purchaseQuantity * item.priceForEach);
    }, 0);

    return (
      <div style={{ overflow: 'hidden', background: '#fff' }}>
        {/* Header */}
        <div style={{
          padding: '12px 16px',
          borderBottom: '1px solid #e8e8e8',
          fontSize: '14px',
          fontWeight: 'bold',
          background: '#fff',
        }}
        >
          Packaging Details
        </div>

        {/* Column Headers */}
        <div style={{
          display: 'flex',
          padding: '12px 16px',
          fontSize: '14px',
          color: '#666',
          background: '#fff',
        }}
        >
          <div style={{ width: '60%' }}>Type</div>
          <div style={{ width: '20%', textAlign: 'center' }}>Quantity</div>
          <div style={{ width: '20%', textAlign: 'right' }}>Price</div>
        </div>

        {/* Packaging Items */}
        <div style={{ padding: '0 16px', background: '#fff' }}>
          {packagingMaterial.map((item: any) => (
            <div
              key={item.id || item.itemId || `${item.itemDesc}-${item.priceForEach}`}
              style={{
                display: 'flex',
                padding: '8px 0',
                fontSize: '14px',
                background: '#fff',
              }}
            >
              <div style={{ width: '60%' }}>{item.itemDesc}</div>
              <div style={{ width: '20%', textAlign: 'center' }}>{item.purchaseQuantity}</div>
              <div style={{ width: '20%', textAlign: 'right' }}>{item.priceForEach}</div>
            </div>
          ))}
        </div>

        {/* Footer with Total */}
        <div style={{
          borderTop: '1px solid #e8e8e8',
          padding: '12px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '14px',
          fontWeight: 'bold',
          background: '#fff',
        }}
        >
          <div>Total Packaging Cost</div>
          <div>{totalCost.toFixed(2)}</div>
        </div>
      </div>
    );
  };
  const handelWeightmismatch = async (values: any) => {
    const body = {
      consignments: [
        {
          reference_number: values.referencenumber as string,
          weight: values.weight as string,
          height: values.height as string,
          length: values.length as string,
          width: values.width as string,
        },
      ],
    };
    const res = await getWeightMismatchSubmit(body);
    setModalLoading(false);

    if (res.isSuccess) {
      const result = res.data;
      if (result.amount) {
        setDifferentialCost(result.amount);
      }
      if (result.proceedBooking && consignmentPaymentStatus === 'none') { // todo recheck someone
        setShowDifferntialCost(false);
        SetShowPaymentStatus('NOT REQUIRED');
        setisPaymentAwaited(false);
      } else {
        if (consignmentPaymentStatus === 'none') {
          SetShowPaymentStatus('AWAITED');
          setVisiblePaymentStatus(false);
          setPaymentLinkButtonText('Send Payment Link');
          setisPaymentAwaited(true);
        }
        setShowDifferntialCost(true);
      }
      handleVerifyDropoff(refNum, lastDropOffCode, false,
        false, isInternationalConsignment, false);
    } else {
      message.error(res.errorMessage || res.error.message);
    }
  };

  const handelWeightmismatchSubmit = () => {
    setModalLoading(true);
    const values = {
      referencenumber: dataSource[0]?.referenceNumber,
      length: dataSource[0]?.length,
      width: dataSource[0]?.breadth,
      height: dataSource[0]?.height,
      weight: dataSource[0]?.weight * 1000,
    };
    handelWeightmismatch(values);
  };

  const sendPaymentLink = async (refNo: string, email: string, phone: string) => {
    const body = {
      consignments: [
        refNo,
      ],
      email,
      phone,
    };

    const res = await weightMismatchPaymentLink(body);
    setModalLoading(false);
    if (res.isSuccess) {
      const result = res.data;
      if (result.proceedBooking) {
        SetShowPaymentStatus('SUCCESS');
      } else {
        SetShowPaymentStatus('AWAITED');
      }
      message.success('Payment Link has been sent');
      handleModalCancel();
      setPaymentLinkButtonText('Resend Payment Link');
      setShowDifferntialCost(false);
    } else {
      message.error(res.errorMessage || res.error.message);
    }
  };
  const handleSendpaymentLinkWeightMismatch = () => {
    setcommunicationModalTitle('WEIGHT MISMATCH');
    setModalLoading(true);
    setIsCommunicationModal(true);
    setIsModalOpen(false);
  };

  const handleSendpaymentLinkOnlineDropoff = () => {
    setcommunicationModalTitle('ONLINE PAYMENT DETAILS');
    setIsCashToOnlineDropoff(true);
    setIsCommunicationModal(true);
    setIsModalOpen(false);
  };

  const handleSendCommunicationDetails = () => {
    setModalLoading(true);
    const referencenumber = dataSource[0]?.referenceNumber;
    const email = consignmentEmail;
    const phone = consignmentphone;
    sendPaymentLink(referencenumber as string, email as string, phone as string);
  };

  const handleSendCommunicationDetailsOnlineDropoff = () => {
    setCollectionLoading(true);
    setIsCommunicationModal(false);
    setCollectCashModalOpen(false);
    const { referenceNumber, validationCode } = dropOffFormData;
    handleVerifyDropoff(referenceNumber as string, validationCode as string, false, false,
      isInternationalConsignment, true);

    form.resetFields();
  };


  const NoteComponent = () => {
    const notes = [
      'Enter AWB and 6-digit dropoff code to get consignment details',
      'Check and ensure that the content declared by the customer and actual content brought for dropoff are the same',
      'Check weight and dimensions of consignment & generate a payment link in case of weight mismatch',
      'Once all details are verified, complete the collection process.',
      'Print Shipping label, affix on shipment and connect to branch',
    ];

    return (
      <Card
        className="note-card"
        style={{
          width: 350,
          margin: '20px 0 20px 0',
          paddingLeft: '30px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <InfoCircleOutlined style={{ fontSize: '20px', color: '#1890ff', marginRight: '8px' }} />
          <Title level={4} style={{ margin: 0 }}>
            Note
          </Title>
        </div>
        <List
          size="small"
          bordered={false}
          dataSource={notes}
          style={{ width: '100%' }}
          renderItem={(item) => (
            <List.Item style={{ paddingLeft: '10px', width: '100%', textDecoration: 'none' }}>
              <Typography.Text style={{ textDecoration: 'none' }}>{item}</Typography.Text>
            </List.Item>
          )}
        />
      </Card>
    );
  };
  const resetWeightmismatchEditing = () => {
    setIsEditing(false);
    seteditingWeightmismatch(null);
    setVisibleSubmitButton(true);
  };

  const RenderModal = () => {
    const actions = [
      {
        key: '7',
        title: 'ACTIONS',
        hidden: isWeightMismatchDisabled,
        render: (record:any) => {
          return (
            <>
              <EditOutlined onClick={() => {
                onEditWeightMismatch(record);
              }}
              />
            </>
          );
        },

      },
    ].filter((item) => !item.hidden);

    const weightMismatchColumnsWithAction = [
      ...weightMismatchColumns,
      ...actions,
    ];

    const exceptThisSymbols = ['e', 'E', '+', '-'];

    return (
      <Modal
        title="WEIGHT MISMATCH"
        open={isModalOpen}
        footer={null}
        width={1000}
        onCancel={handleModalCancel}
        className={classes.modal}
      >
        <div>
          <Table
            columns={weightMismatchColumnsWithAction}
            dataSource={dataSource}
            pagination={false}
            loading={modalLoading}
            bordered
          />
        </div>
        <div className={classes.modalButtons}>
          {
            ShowDifferntialCost
              ? (
                <label className={classes.differentailCost}>
                  {'Differential Cost: '}
                  {differentialCost || 0}
                </label>
              ) : null
          }
          {
            ShowPaymentStatus !== 'none' && visiblePaymentStatus
              ? (
                <label className={classes.weightmismatchPaymentStatus}>
                  {'Current Payment Status: '}
                  {ShowPaymentStatus}
                </label>
              ) : null
          }
          {
            isPaymentAwaited
              ? (
                <Button
                  className={classes.weightmismatchSubmitButton}
                  onClick={handleSendpaymentLinkWeightMismatch}
                >
                  {paymentLinkButtonText}
                </Button>
              ) : null
          }
          {
            visibleSubmitButton
              ? (
                <Button
                  className={classes.weightmismatchSubmitButton}
                  onClick={handelWeightmismatchSubmit}
                  style={{
                    width: '180px',
                    padding: '3px',
                  }}
                >
                  SHOW DIFFERENTIAL COST
                </Button>
              ) : null
          }
          {
            consignmentPaymentStatus !== 'none' && ShowDifferntialCost
              ? (
                <>
                  <Button
                    className={classes.weightmismatchSubmitButton}
                    onClick={handleModalCancel}
                    disabled={!ShowDifferntialCost}
                  >
                    CONFIRM
                  </Button>
                </>
              ) : null
          }
        </div>
        <Modal
          title={(
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  onClick={() => cancelDimensionsModal()}
                  style={{
                    fontSize: '20px',
                    marginRight: '12px',
                    cursor: 'pointer',
                  }}
                >
                  ×
                </span>
                <span>Weight Mismatch</span>
              </div>
              <Button
                type="primary"
                onClick={() => {
                  // Handle the proceed action - update the data and close modal
                  setDataSource((prev: any[]) => {
                    return prev.map((element: any) => {
                      if (element.id === editingWightmmismatch.id) {
                        return editingWightmmismatch;
                      }
                      return element;
                    });
                  });
                  resetWeightmismatchEditing();
                }}
                style={{
                  backgroundColor: '#0E2C53 !important',
                  color: '#fff !important',
                  border: 'none',
                  marginLeft: 'auto',
                }}
              >
                Proceed
              </Button>
            </div>
      )}
          open={isEditing}
          onCancel={() => {
            cancelDimensionsModal();
          }}
          footer={null}
          width={450}
          bodyStyle={{ height: '600px' }}
          closeIcon={<></>}
        >
          <Alert
            message="Please note that any update in the details will incur additional cost that has to be settled for smooth delivery"
            type="warning"
            style={{
              marginBottom: '20px',
              backgroundColor: '#FFF9DB',
              border: '1px solid #FFE58F',
              borderRadius: '4px',
            }}
          />

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: '140px', flexShrink: 0 }}>Consignment Number</div>
              <Input
                value={editingWightmmismatch?.referenceNumber}
                disabled
                style={{ width: '100%' }}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: '140px', flexShrink: 0 }}>Weight (Kg)</div>
              <Input
                value={editingWightmmismatch?.weight}
                type="number"
                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                onChange={(element) => {
                  seteditingWeightmismatch((prev: any) => {
                    return { ...prev, weight: element.target.value };
                  });
                }}
                style={{ width: '100%' }}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: '140px', flexShrink: 0 }}>Length (cm)</div>
              <Input
                value={editingWightmmismatch?.length}
                type="number"
                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                onChange={(element) => {
                  seteditingWeightmismatch((prev: any) => {
                    return { ...prev, length: element.target.value };
                  });
                }}
                style={{ width: '100%' }}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: '140px', flexShrink: 0 }}>Breadth (cm)</div>
              <Input
                value={editingWightmmismatch?.breadth}
                type="number"
                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                onChange={(element) => {
                  seteditingWeightmismatch((prev: any) => {
                    return { ...prev, breadth: element.target.value };
                  });
                }}
                style={{ width: '100%' }}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ width: '140px', flexShrink: 0 }}>Height (cm)</div>
              <Input
                value={editingWightmmismatch?.height}
                type="number"
                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                onChange={(element) => {
                  seteditingWeightmismatch((prev: any) => {
                    return { ...prev, height: element.target.value };
                  });
                }}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </Modal>
      </Modal>
    );
  };

  const handleCollectCash = () => {
    setCollectCashModalOpen(false);
    setCollectionLoading(true);
    const { referenceNumber, validationCode } = dropOffFormData;
    handleVerifyDropoff(referenceNumber as string, validationCode as string,
      true, true, isInternationalConsignment, false);
    form.resetFields();
  };


  const handleCashCollectionCancel = () => {
    setCollectCashModalOpen(false);
  };

  const CustomHeader: React.FC<{
    onClose: () => void;
    onSendPaymentLink: () => void;
    onCollectCash: () => void;
    showPaymentLinkButton: boolean;
  }> = ({
    onClose,
    onSendPaymentLink,
    onCollectCash,
    showPaymentLinkButton,
  }) => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CloseOutlined
          onClick={onClose}
          style={{
            fontSize: '20px',
            cursor: 'pointer',
            marginRight: '12px',
          }}
        />
        <span style={{ fontSize: '16px', fontWeight: 500 }}>Payment</span>
      </div>

      <div style={{ display: 'flex', gap: '12px' }}>
        {showPaymentLinkButton && (
          <Button
            size="middle"
            onClick={onSendPaymentLink}
          >
            Send Payment Link
          </Button>
        )}
        <Button
          type="primary"
          size="middle"
          onClick={onCollectCash}
          style={{
            backgroundColor: '#1D4ED8',
            borderColor: '#1D4ED8',
          }}
        >
          Collect Cash
        </Button>
      </div>
    </div>
  );

  const handleAlertCancel = () => {
    setIsAlertModalOpen(false); // Close modal
  };

  const handleAlertContinue = async () => {
    setIsAlertModalOpen(false); // Close modal after confirmation
    handleVerifyDropoff(refNum as string, lastDropOffCode as string,
      false, false, false, false, true);
  };

  const RenderDropOffLocationChangeModal = () => {
    return (
      <Modal
        title={null}
        open={isAlertModalOpen}
        footer={null}
        width={450}
        bodyStyle={{
          padding: '0',
          maxHeight: '90vh',
          overflow: 'auto',
          height: '300px',
        }}
        onCancel={handleAlertCancel}
        closeIcon={null}
      >
        {/* Header */}
        <div
          style={{
            borderBottom: '1px solid #f0f0f0',
            padding: '16px 24px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: 20, marginRight: 8 }} />
          <span style={{ fontSize: 16, fontWeight: 600 }}>Attention</span>
        </div>

        {/* Body */}
        <div style={{ padding: '20px 24px' }}>
          <h3 style={{
            fontSize: 16,
            fontWeight: 500,
            marginBottom: 12,
          }}
          >
            Drop off location change
          </h3>
          <p style={{ fontSize: 14, color: '#595959', lineHeight: 1.6 }}>
            <span style={{ cursor: 'pointer' }}>
              You are dropping off your shipment at a different location.
              This may change the origin location and add extra charges. Do you wish to continue?
            </span>
          </p>

          {/* Footer Buttons */}
          <Row justify="end" style={{ marginTop: 32 }}>
            <Col>
              <button
                type="button"
                onClick={handleAlertCancel}
                style={{
                  padding: '6px 16px',
                  marginRight: 12,
                  backgroundColor: 'transparent',
                  border: '1px solid #d9d9d9',
                  borderRadius: 4,
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleAlertContinue}
                style={{
                  padding: '6px 16px',
                  backgroundColor: '#10239e',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 4,
                  cursor: 'pointer',
                }}
              >
                Yes, Continue
              </button>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  };

  const RenderCashCollectionModal = () => {
    const packingMessage = (packagingAmount > 0);
    const weightMismatchMessage = (differentialCost > 0);
    const showOnlinePaymentButton = window.localStorage.getItem('allowCashPaymentForDropOff');

    // Dialog to show when collecting cash
    return (
      <Modal
        title={null}
        open={isCollectCashModalOpen}
        footer={null}
        width={450}
        bodyStyle={{
          padding: '0',
          maxHeight: '90vh',
          overflow: 'auto',
          height: '550px',
        }}
        onCancel={handleCashCollectionCancel}
        className={classes?.cashModal || ''}
        closeIcon={<></>}
      >
        {/* Custom Header */}
        <div style={{
          borderBottom: '1px solid #f0f0f0',
          padding: '16px 24px',
        }}
        >
          <CustomHeader
            onClose={handleCashCollectionCancel}
            onSendPaymentLink={handleSendpaymentLinkOnlineDropoff}
            onCollectCash={handleCollectCash}
            showPaymentLinkButton={!!(consignmentPaymentStatus === 'PENDING' && showOnlinePaymentButton)}
          />
        </div>

        {/* Body Content */}
        <div style={{ padding: '20px 24px' }}>
          {/* Tariff Amount - Always shown */}
          <Row style={{ marginBottom: '12px' }}>
            <Col span={16}>
              <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.85)' }}>
                Tariff Amount
              </span>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <span style={{ fontSize: '14px', fontWeight: 500 }}>
                INR
                {' '}
                {tariffCharges}
              </span>
            </Col>
          </Row>

          {/* Shipment Mismatch Amount */}
          {editDetailsAmount ? (
            <Row style={{ marginBottom: '12px' }}>
              <Col span={16}>
                <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.85)' }}>
                  Shipment Detail Mismatch Charges
                </span>
              </Col>
              <Col span={8} style={{ textAlign: 'right' }}>
                <span style={{ fontSize: '14px', fontWeight: 500 }}>
                  INR
                  {' '}
                  {editDetailsAmount}
                </span>
              </Col>
            </Row>
          ) : null }

          {locationChangeAmount ? (
            <Row style={{ marginBottom: '12px' }}>
              <Col span={16}>
                <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.85)' }}>
                  Location Change Charges
                </span>
              </Col>
              <Col span={8} style={{ textAlign: 'right' }}>
                <span style={{ fontSize: '14px', fontWeight: 500 }}>
                  INR
                  {' '}
                  {locationChangeAmount}
                </span>
              </Col>
            </Row>
          ) : null }

          {/* Weight Mismatch Charges - Conditional */}
          {weightMismatchMessage && (
          <Row style={{ marginBottom: '12px' }}>
            <Col span={16}>
              <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.85)' }}>
                Weight Mismatch Charges
              </span>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <span style={{ fontSize: '14px', fontWeight: 500 }}>
                INR
                {' '}
                {differentialCost}
              </span>
            </Col>
          </Row>
          )}

          {/* Packaging Material Charges - Conditional */}
          {packingMessage && (
          <Row style={{ marginBottom: '12px' }}>
            <Col span={16}>
              <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.85)' }}>
                Packaging Material Charges
              </span>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <span style={{ fontSize: '14px', fontWeight: 500 }}>
                INR
                {' '}
                {packagingAmount}
              </span>
            </Col>
          </Row>
          )}

          {/* Total Amount */}
          <Row style={{ marginTop: '16px', borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
            <Col span={16}>
              <span style={{ fontSize: '14px', fontWeight: 600 }}>
                Amount to be collected
              </span>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <span style={{ fontSize: '14px', fontWeight: 600 }}>
                INR
                {' '}
                {amountPending}
              </span>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  };


  const handlePhoneNoChange = (e: any) => {
    const inputValue = e.target.value;
    setconsignmentphone(inputValue);

    const regex = /^(?!.*(\d)\1{9})(0[6-9]\d{9}|(?:(\+91)?[6-9]\d{9})|(?:(91)?[6-9]\d{9}))$/;
    const isValidNumber = regex.test(inputValue);
    setValidPhone(isValidNumber);
  };

  const handleEmailChange = (e: any) => {
    const inputValue = e.target.value;
    setConsignmentEmail(inputValue);

    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValidEmailValue = regex.test(inputValue);
    setValidEmail(isValidEmailValue);
  };

  const disableButton = () => {
    return (!isValidPhone || !isValidEmail);
  };

  const RenderContactDetailsModal = () => {
    const disable = disableButton();
    return (
      <Modal
        title={communicationModalTitle}
        open={isCommunicationModal}
        footer={null}
        width={1000}
        onCancel={handleCommunicationModalCancel}
        className={classes.modal}
      >
        <div>
          <div className={classes.communicationModalFields}>
            <label>Phone</label>
            <div className={classes.coummunicationModalErrHandling}>
              <Input
                className={classes.communicationModalInputFields}
                value={consignmentphone}
                type="tel"
                onChange={(e) => handlePhoneNoChange(e)}
              />
              {isValidPhone ? null : <p>Invalid phone number</p>}
            </div>
          </div>
          <div className={classes.communicationEmailField}>
            <label>EMAIL</label>
            <div className={classes.coummunicationModalErrHandling}>
              <Input
                className={classes.communicationModalInputFields}
                value={consignmentEmail}
                type="email"
                onChange={(e) => handleEmailChange(e)}
              />
              {isValidEmail ? null : <p>Invalid Email Id</p>}
            </div>
          </div>
        </div>
        <div className={classes.modalButtons}>
          {
            isCashToOnlineDropoff
              ? (
                <Button
                  className={classes.weightmismatchSubmitButton}
                  onClick={handleSendCommunicationDetailsOnlineDropoff}
                  disabled={disable}
                >
                  Send Payment Link
                </Button>
              ) : null
          }
          {
            isPaymentAwaited
              ? (
                <Button
                  className={classes.weightmismatchSubmitButton}
                  onClick={handleSendCommunicationDetails}
                  disabled={disable}
                >
                  {paymentLinkButtonText}
                </Button>
              ) : null
          }
        </div>
      </Modal>
    );
  };

  const renderFinalData = () => {
    return (
      <>

        {isEditDetailsModalOpen && renderEditDetailsModal()}
        {renderShipmentInfo()}
        <Row gutter={[0, 0]}>
          <Col xs={24} sm={24} md={12}>
            {renderSenderDetails()}
          </Col>
          <Col xs={24} sm={24} md={12}>
            {renderPaymentInfo()}
          </Col>
        </Row>
        <Row gutter={[0, 0]}>
          <Col xs={24} sm={24} md={12}>
            {renderDestinationDetails()}
          </Col>
          <Col xs={24} sm={24} md={12}>
            {renderPackagingDetails()}
          </Col>
        </Row>
      </>
    );
  };

  const renderDropOffDetails = () => {
    return (
      <div className={classes.dropOffDetailsForm}>

        {isPackageModalOpen
          ? (
            <PackageOption
              isPackageModalOpen={isPackageModalOpen}
              setIsPackageModalOpen={setIsPackageModalOpen}
              referenceNumber={dropOffFormData?.referenceNumber}
              verifiedConsignmentDetail={verifiedConsignmentDetail}
              handleReloadDropOff={handleReloadDropOff}
              showPaymentStatus={ShowPaymentStatus}
              isInternational={isInternationalConsignment}
            />
          )
          : null}
        {RenderModal()}
        {RenderCashCollectionModal()}
        {renderPaymentModal()}
        {RenderContactDetailsModal()}
      </div>
    );
  };

  const renderInvalidDropoff = () => {
    return (
      <div className={classes.dropOffDetailsForm}>
        {renderDetailsHeading()}
        <img
          className={classes.logoStyle}
          src={dropoff_invalid}
          alt="Invalid Dropoff"
        />
        <div className={classes.errorMessageText}>
          {dropOffMessage || 'Invalid Dropoff'}
        </div>
        {renderOkayButton()}
      </div>
    );
  };

  const renderTabs = () => {
    const tabs = [
      { name: 'Upcoming', Component: <TabularDropoff status="UPCOMING" /> },
      { name: 'Completed', Component: <TabularDropoff status="COMPLETED" /> },
      { name: 'Rejected', Component: <TabularDropoff status="REJECTED" /> },
    ];
    return tabs;
  };

  const renderDropoffRequestMain = () => {
    return (
      <div className={classes.dropOffMain}>
        <div className={classes.leftPart}>
          {renderDropOffForm()}
          {NoteComponent()}
          {showInvalidDropoff && renderInvalidDropoff()}
          {showValidDropoff && renderValidDropOff()}
          {showDropoffDetails && renderDropOffDetails()}
          {isAlertModalOpen && RenderDropOffLocationChangeModal()}
        </div>
        <div className={classes.rightPart}>
          {isFullPageModalOpen && renderButtons()}
          {isFullPageModalOpen && renderFinalData()}
          {!isFullPageModalOpen && <CustomTabs tabs={renderTabs()} destroyInactiveTabPane />}
        </div>
      </div>
    );
  };
  React.useEffect(() => {
    if (isEditDetailsModalOpen && form.getFieldValue('serviceType')) {
      form.validateFields(['serviceType']).catch(() => {
      });
    }
  }, [serviceTypes, form.getFieldValue('destinationPincode'), isEditDetailsModalOpen]);

  React.useEffect(() => {
    if (isEditDetailsModalOpen && serviceTypes.length > 0) {
      const formValues = form.getFieldsValue();
      const selectedServiceType = serviceTypes.some((type) => type.serviceType
      === formValues.serviceType);
      setIsServiceTypeValid(selectedServiceType);
    }
  }, [serviceTypes, isEditDetailsModalOpen, Form.useWatch('serviceType', form)]);

  return (
    <div className={classes.contentDiv}>
      {renderDropoffRequestMain()}
    </div>
  );
};

const hocConfig: HocOptions = {
  connectRedux: {
    useRedux: true,
  },
  connectJss: {
    useJss: true,
    styleSheet: dropoffStyles,
  },
  connectRouter: true,
};

export default GenericHoc(hocConfig)(DropoffPage);
